import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { App } from "./App";
import { ConsoleAuthProvider } from "./auth/AuthProvider";
import { TenantThemeProvider } from "./admin/components/TenantThemeProvider";
import { ViewportShellSync } from "./components/ViewportShellSync/ViewportShellSync";
import { loadConsoleConfig } from "./runtimeConfig";
import "./index.css";

initializeIcons();

/**
 * Console entry point. Runtime config is awaited before anything that reads it
 * initialises - the same order the product SPA's index.tsx uses, and the reason
 * msalInstance builds its configuration lazily.
 */
async function bootstrap() {
  const container = document.getElementById("root");
  if (!container) {
    return;
  }
  const root = createRoot(container);
  try {
    await loadConsoleConfig();
  } catch {
    root.render(
      <p>
        Cortex Console configuration is unavailable, so sign-in cannot start. Nothing
        was read. Try again shortly.
      </p>,
    );
    return;
  }
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ConsoleAuthProvider>
          <TenantThemeProvider>
            <ViewportShellSync />
            <App />
          </TenantThemeProvider>
        </ConsoleAuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap();
